export const provinceCanada = [
  {
    selectedLabel: 'Alberta',
    label: 'Alberta',
    value: 'AB',
  },
  {
    selectedLabel: 'British Columbia',
    label: 'British Columbia',
    value: 'BC',
  },
  {
    selectedLabel: 'Manitoba',
    label: 'Manitoba',
    value: 'MB',
  },
  {
    selectedLabel: 'New Brunswick',
    label: 'New Brunswick',
    value: 'NB',
  },
  {
    selectedLabel: 'Newfoundland and Labrador',
    label: 'Newfoundland and Labrador',
    value: 'NL',
  },
  {
    selectedLabel: 'Northwest Territories',
    label: 'Northwest Territories',
    value: 'NT',
  },
  {
    selectedLabel: 'Nova Scotia',
    label: 'Nova Scotia',
    value: 'NS',
  },
  {
    selectedLabel: 'Nunavut',
    label: 'Nunavut',
    value: 'NU',
  },
  {
    selectedLabel: 'Ontario',
    label: 'Ontario',
    value: 'ON',
  },
  {
    selectedLabel: 'Prince Edward Island',
    label: 'Prince Edward Island',
    value: 'PE',
  },
  {
    selectedLabel: 'Quebec',
    label: 'Quebec',
    value: 'QC',
  },
  {
    selectedLabel: 'Saskatchewan',
    label: 'Saskatchewan',
    value: 'SK',
  },
  {
    selectedLabel: 'Yukon',
    label: 'Yukon',
    value: 'YT',
  },
];

export const stateUSA = [
  {
    selectedLabel: 'Alabama',
    label: 'Alabama',
    value: 'AL',
  },
  {
    selectedLabel: 'Alaska',
    label: 'Alaska',
    value: 'AK',
  },
  {
    selectedLabel: 'Arizona',
    label: 'Arizona',
    value: 'AZ',
  },
  {
    selectedLabel: 'Arkansas',
    label: 'Arkansas',
    value: 'AR',
  },
  {
    selectedLabel: 'California',
    label: 'California',
    value: 'CA',
  },
  {
    selectedLabel: 'Colorado',
    label: 'Colorado',
    value: 'CO',
  },
  {
    selectedLabel: 'Connecticut',
    label: 'Connecticut',
    value: 'CT',
  },
  {
    selectedLabel: 'Delaware',
    label: 'Delaware',
    value: 'DE',
  },
  {
    selectedLabel: 'Florida',
    label: 'Florida',
    value: 'FL',
  },
  {
    selectedLabel: 'Georgia',
    label: 'Georgia',
    value: 'GA',
  },
  {
    selectedLabel: 'Hawaii',
    label: 'Hawaii',
    value: 'HI',
  },
  {
    selectedLabel: 'Idaho',
    label: 'Idaho',
    value: 'ID',
  },
  {
    selectedLabel: 'Illinois',
    label: 'Illinois',
    value: 'IL',
  },
  {
    selectedLabel: 'Indiana',
    label: 'Indiana',
    value: 'IN',
  },
  {
    selectedLabel: 'Iowa',
    label: 'Iowa',
    value: 'IA',
  },
  {
    selectedLabel: 'Kansas',
    label: 'Kansas',
    value: 'KS',
  },
  {
    selectedLabel: 'Kentucky',
    label: 'Kentucky',
    value: 'KY',
  },
  {
    selectedLabel: 'Louisiana',
    label: 'Louisiana',
    value: 'LA',
  },
  {
    selectedLabel: 'Maine',
    label: 'Maine',
    value: 'ME',
  },
  {
    selectedLabel: 'Maryland',
    label: 'Maryland',
    value: 'MD',
  },
  {
    selectedLabel: 'Massachusetts',
    label: 'Massachusetts',
    value: 'MA',
  },
  {
    selectedLabel: 'Michigan',
    label: 'Michigan',
    value: 'MI',
  },
  {
    selectedLabel: 'Minnesota',
    label: 'Minnesota',
    value: 'MN',
  },
  {
    selectedLabel: 'Mississippi',
    label: 'Mississippi',
    value: 'MS',
  },
  {
    selectedLabel: 'Missouri',
    label: 'Missouri',
    value: 'MO',
  },
  {
    selectedLabel: 'Montana',
    label: 'Montana',
    value: 'MT',
  },
  {
    selectedLabel: 'Nebraska',
    label: 'Nebraska',
    value: 'NE',
  },
  {
    selectedLabel: 'Nevada',
    label: 'Nevada',
    value: 'NV',
  },
  {
    selectedLabel: 'New Hampshire',
    label: 'New Hampshire',
    value: 'NH',
  },
  {
    selectedLabel: 'New Jersey',
    label: 'New Jersey',
    value: 'NJ',
  },
  {
    selectedLabel: 'New Mexico',
    label: 'New Mexico',
    value: 'NM',
  },
  {
    selectedLabel: 'New York',
    label: 'New York',
    value: 'NY',
  },
  {
    selectedLabel: 'North Carolina',
    label: 'North Carolina',
    value: 'NC',
  },
  {
    selectedLabel: 'North Dakota',
    label: 'North Dakota',
    value: 'ND',
  },
  {
    selectedLabel: 'Ohio',
    label: 'Ohio',
    value: 'OH',
  },
  {
    selectedLabel: 'Oklahoma',
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    selectedLabel: 'Oregon',
    label: 'Oregon',
    value: 'OR',
  },
  {
    selectedLabel: 'Pennsylvania',
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    selectedLabel: 'Rhode Island',
    label: 'Rhode Island',
    value: 'RI',
  },
  {
    selectedLabel: 'South Carolina',
    label: 'South Carolina',
    value: 'SC',
  },
  {
    selectedLabel: 'South Dakota',
    label: 'South Dakota',
    value: 'SD',
  },
  {
    selectedLabel: 'Tennessee',
    label: 'Tennessee',
    value: 'TN',
  },
  {
    selectedLabel: 'Texas',
    label: 'Texas',
    value: 'TX',
  },
  {
    selectedLabel: 'Utah',
    label: 'Utah',
    value: 'UT',
  },
  {
    selectedLabel: 'Vermont',
    label: 'Vermont',
    value: 'VT',
  },
  {
    selectedLabel: 'Virginia',
    label: 'Virginia',
    value: 'VA',
  },
  {
    selectedLabel: 'Washington',
    label: 'Washington',
    value: 'WA',
  },
  {
    selectedLabel: 'West Virginia',
    label: 'West Virginia',
    value: 'WV',
  },
  {
    selectedLabel: 'Wisconsin',
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    selectedLabel: 'Wyoming',
    label: 'Wyoming',
    value: 'WY',
  },
];

export const countries = [
  {
    value: 'AF',
    selectedLabel: 'Afghanistan',
    label: 'Afghanistan',
  },
  {
    value: 'AL',
    selectedLabel: 'Albania',
    label: 'Albania',
  },
  {
    value: 'DZ',
    selectedLabel: 'Algeria',
    label: 'Algeria',
  },
  {
    value: 'AS',
    selectedLabel: 'American Samoa',
    label: 'American Samoa',
  },
  {
    value: 'AD',
    selectedLabel: 'Andorra',
    label: 'Andorra',
  },
  {
    value: 'AO',
    selectedLabel: 'Angola',
    label: 'Angola',
  },
  {
    value: 'AI',
    selectedLabel: 'Anguilla',
    label: 'Anguilla',
  },
  {
    value: 'AQ',
    selectedLabel: 'Antarctica',
    label: 'Antarctica',
  },
  {
    value: 'AG',
    selectedLabel: 'Antigua and Barbuda',
    label: 'Antigua and Barbuda',
  },
  {
    value: 'AR',
    selectedLabel: 'Argentina',
    label: 'Argentina',
  },
  {
    value: 'AM',
    selectedLabel: 'Armenia',
    label: 'Armenia',
  },
  {
    value: 'AW',
    selectedLabel: 'Aruba',
    label: 'Aruba',
  },
  {
    value: 'AU',
    selectedLabel: 'Australia',
    label: 'Australia',
  },
  {
    value: 'AT',
    selectedLabel: 'Austria',
    label: 'Austria',
  },
  {
    value: 'AZ',
    selectedLabel: 'Azerbaijan',
    label: 'Azerbaijan',
  },
  {
    value: 'BS',
    selectedLabel: 'Bahamas',
    label: 'Bahamas',
  },
  {
    value: 'BH',
    selectedLabel: 'Bahrain',
    label: 'Bahrain',
  },
  {
    value: 'BD',
    selectedLabel: 'Bangladesh',
    label: 'Bangladesh',
  },
  {
    value: 'BB',
    selectedLabel: 'Barbados',
    label: 'Barbados',
  },
  {
    value: 'BY',
    selectedLabel: 'Belarus',
    label: 'Belarus',
  },
  {
    value: 'BE',
    selectedLabel: 'Belgium',
    label: 'Belgium',
  },
  {
    value: 'BZ',
    selectedLabel: 'Belize',
    label: 'Belize',
  },
  {
    value: 'BJ',
    selectedLabel: 'Benin',
    label: 'Benin',
  },
  {
    value: 'BM',
    selectedLabel: 'Bermuda',
    label: 'Bermuda',
  },
  {
    value: 'BT',
    selectedLabel: 'Bhutan',
    label: 'Bhutan',
  },
  {
    value: 'BO',
    selectedLabel: 'Bolivia',
    label: 'Bolivia',
  },
  {
    value: 'BA',
    selectedLabel: 'Bosnia and Herzegovina',
    label: 'Bosnia and Herzegovina',
  },
  {
    value: 'BW',
    selectedLabel: 'Botswana',
    label: 'Botswana',
  },
  {
    value: 'BV',
    selectedLabel: 'Bouvet Island (Bouvetoya)',
    label: 'Bouvet Island (Bouvetoya)',
  },
  {
    value: 'BR',
    selectedLabel: 'Brazil',
    label: 'Brazil',
  },
  {
    value: 'IO',
    selectedLabel: 'British Indian Ocean Territory (Chagos Archipelago)',
    label: 'British Indian Ocean Territory (Chagos Archipelago)',
  },
  {
    value: 'VG',
    selectedLabel: 'British Virgin Islands',
    label: 'British Virgin Islands',
  },
  {
    value: 'BN',
    selectedLabel: 'Brunei',
    label: 'Brunei',
  },
  {
    value: 'BG',
    selectedLabel: 'Bulgaria',
    label: 'Bulgaria',
  },
  {
    value: 'BF',
    selectedLabel: 'Burkina Faso',
    label: 'Burkina Faso',
  },
  {
    value: 'BI',
    selectedLabel: 'Burundi',
    label: 'Burundi',
  },
  {
    value: 'KH',
    selectedLabel: 'Cambodia',
    label: 'Cambodia',
  },
  {
    value: 'CM',
    selectedLabel: 'Cameroon',
    label: 'Cameroon',
  },
  {
    value: 'CA',
    selectedLabel: 'Canada',
    label: 'Canada',
  },
  {
    value: 'CV',
    selectedLabel: 'Cape Verde',
    label: 'Cape Verde',
  },
  {
    value: 'KY',
    selectedLabel: 'Cayman Islands',
    label: 'Cayman Islands',
  },
  {
    value: 'CF',
    selectedLabel: 'Central African Republic',
    label: 'Central African Republic',
  },
  {
    value: 'TD',
    selectedLabel: 'Chad',
    label: 'Chad',
  },
  {
    value: 'CL',
    selectedLabel: 'Chile',
    label: 'Chile',
  },
  {
    value: 'CN',
    selectedLabel: 'China',
    label: 'China',
  },
  {
    value: 'CX',
    selectedLabel: 'Christmas Island',
    label: 'Christmas Island',
  },
  {
    value: 'CC',
    selectedLabel: 'Cocos (Keeling) Islands',
    label: 'Cocos (Keeling) Islands',
  },
  {
    value: 'CO',
    selectedLabel: 'Colombia',
    label: 'Colombia',
  },
  {
    value: 'KM',
    selectedLabel: 'Comoros',
    label: 'Comoros',
  },
  {
    value: 'CG',
    selectedLabel: 'Congo - Brazzaville',
    label: 'Congo - Brazzaville',
  },
  {
    value: 'CD',
    selectedLabel: 'Congo - Kinshasa',
    label: 'Congo - Kinshasa',
  },
  {
    value: 'CK',
    selectedLabel: 'Cook Islands',
    label: 'Cook Islands',
  },
  {
    value: 'CR',
    selectedLabel: 'Costa Rica',
    label: 'Costa Rica',
  },
  {
    value: 'HR',
    selectedLabel: 'Croatia',
    label: 'Croatia',
  },
  {
    value: 'CU',
    selectedLabel: 'Cuba',
    label: 'Cuba',
  },
  {
    value: 'CY',
    selectedLabel: 'Cyprus',
    label: 'Cyprus',
  },
  {
    value: 'CZ',
    selectedLabel: 'Czech Republic',
    label: 'Czech Republic',
  },
  {
    value: 'CI',
    selectedLabel: 'Ivory Coast',
    label: 'Ivory Coast',
  },
  {
    value: 'DK',
    selectedLabel: 'Denmark',
    label: 'Denmark',
  },
  {
    value: 'DJ',
    selectedLabel: 'Djibouti',
    label: 'Djibouti',
  },
  {
    value: 'DM',
    selectedLabel: 'Dominica',
    label: 'Dominica',
  },
  {
    value: 'DO',
    selectedLabel: 'Dominican Republic',
    label: 'Dominican Republic',
  },
  {
    value: 'EC',
    selectedLabel: 'Ecuador',
    label: 'Ecuador',
  },
  {
    value: 'EG',
    selectedLabel: 'Egypt',
    label: 'Egypt',
  },
  {
    value: 'SV',
    selectedLabel: 'El Salvador',
    label: 'El Salvador',
  },
  {
    value: 'GQ',
    selectedLabel: 'Equatorial Guinea',
    label: 'Equatorial Guinea',
  },
  {
    value: 'ER',
    selectedLabel: 'Eritrea',
    label: 'Eritrea',
  },
  {
    value: 'EE',
    selectedLabel: 'Estonia',
    label: 'Estonia',
  },
  {
    value: 'ET',
    selectedLabel: 'Ethiopia',
    label: 'Ethiopia',
  },
  {
    value: 'FO',
    selectedLabel: 'Faroe Islands',
    label: 'Faroe Islands',
  },
  {
    value: 'FK',
    selectedLabel: 'Falkland Islands (Malvinas)',
    label: 'Falkland Islands (Malvinas)',
  },
  {
    value: 'FJ',
    selectedLabel: 'Fiji, Republic of the Fiji Islands',
    label: 'Fiji, Republic of the Fiji Islands',
  },
  {
    value: 'FI',
    selectedLabel: 'Finland',
    label: 'Finland',
  },
  {
    value: 'FR',
    selectedLabel: 'France',
    label: 'France',
  },
  {
    value: 'GF',
    selectedLabel: 'French Guiana',
    label: 'French Guiana',
  },
  {
    value: 'PF',
    selectedLabel: 'French Polynesia',
    label: 'French Polynesia',
  },
  {
    value: 'TF',
    selectedLabel: 'French Southern Territories',
    label: 'French Southern Territories',
  },
  {
    value: 'GA',
    selectedLabel: 'Gabon',
    label: 'Gabon',
  },
  {
    value: 'GM',
    selectedLabel: 'Gambia',
    label: 'Gambia',
  },
  {
    value: 'GE',
    selectedLabel: 'Georgia',
    label: 'Georgia',
  },
  {
    value: 'DE',
    selectedLabel: 'Germany',
    label: 'Germany',
  },
  {
    value: 'GH',
    selectedLabel: 'Ghana',
    label: 'Ghana',
  },
  {
    value: 'GI',
    selectedLabel: 'Gibraltar',
    label: 'Gibraltar',
  },
  {
    value: 'GR',
    selectedLabel: 'Greece',
    label: 'Greece',
  },
  {
    value: 'GL',
    selectedLabel: 'Greenland',
    label: 'Greenland',
  },
  {
    value: 'GD',
    selectedLabel: 'Grenada',
    label: 'Grenada',
  },
  {
    value: 'GP',
    selectedLabel: 'Guadeloupe',
    label: 'Guadeloupe',
  },
  {
    value: 'GU',
    selectedLabel: 'Guam',
    label: 'Guam',
  },
  {
    value: 'GT',
    selectedLabel: 'Guatemala',
    label: 'Guatemala',
  },
  {
    value: 'GN',
    selectedLabel: 'Guinea',
    label: 'Guinea',
  },
  {
    value: 'GW',
    selectedLabel: 'Guinea-Bissau',
    label: 'Guinea-Bissau',
  },
  {
    value: 'GY',
    selectedLabel: 'Guyana',
    label: 'Guyana',
  },
  {
    value: 'HT',
    selectedLabel: 'Haiti',
    label: 'Haiti',
  },
  {
    value: 'HM',
    selectedLabel: 'Heard and McDonald Islands',
    label: 'Heard and McDonald Islands',
  },
  {
    value: 'HN',
    selectedLabel: 'Honduras',
    label: 'Honduras',
  },
  {
    value: 'HK',
    selectedLabel: 'Hong Kong SAR China',
    label: 'Hong Kong SAR China',
  },
  {
    value: 'HU',
    selectedLabel: 'Hungary',
    label: 'Hungary',
  },
  {
    value: 'IS',
    selectedLabel: 'Iceland',
    label: 'Iceland',
  },
  {
    value: 'IN',
    selectedLabel: 'India',
    label: 'India',
  },
  {
    value: 'ID',
    selectedLabel: 'Indonesia',
    label: 'Indonesia',
  },
  {
    value: 'IR',
    selectedLabel: 'Iran',
    label: 'Iran',
  },
  {
    value: 'IQ',
    selectedLabel: 'Iraq',
    label: 'Iraq',
  },
  {
    value: 'IE',
    selectedLabel: 'Ireland',
    label: 'Ireland',
  },
  {
    value: 'IL',
    selectedLabel: 'Israel',
    label: 'Israel',
  },
  {
    value: 'IT',
    selectedLabel: 'Italy',
    label: 'Italy',
  },
  {
    value: 'JM',
    selectedLabel: 'Jamaica',
    label: 'Jamaica',
  },
  {
    value: 'JP',
    selectedLabel: 'Japan',
    label: 'Japan',
  },
  {
    value: 'JO',
    selectedLabel: 'Jordan',
    label: 'Jordan',
  },
  {
    value: 'KZ',
    selectedLabel: 'Kazakhstan',
    label: 'Kazakhstan',
  },
  {
    value: 'KE',
    selectedLabel: 'Kenya',
    label: 'Kenya',
  },
  {
    value: 'KI',
    selectedLabel: 'Kiribati',
    label: 'Kiribati',
  },
  {
    value: 'KP',
    selectedLabel: 'Korea, North',
    label: 'Korea, North',
  },
  {
    value: 'KR',
    selectedLabel: 'Korea, South',
    label: 'Korea, South',
  },
  {
    value: 'KW',
    selectedLabel: 'Kuwait',
    label: 'Kuwait',
  },
  {
    value: 'KG',
    selectedLabel: 'Kyrgyz Republic',
    label: 'Kyrgyz Republic',
  },
  {
    value: 'LA',
    selectedLabel: 'Laos',
    label: 'Laos',
  },
  {
    value: 'LV',
    selectedLabel: 'Latvia',
    label: 'Latvia',
  },
  {
    value: 'LB',
    selectedLabel: 'Lebanon',
    label: 'Lebanon',
  },
  {
    value: 'LS',
    selectedLabel: 'Lesotho',
    label: 'Lesotho',
  },
  {
    value: 'LR',
    selectedLabel: 'Liberia',
    label: 'Liberia',
  },
  {
    value: 'LY',
    selectedLabel: 'Libya',
    label: 'Libya',
  },
  {
    value: 'LI',
    selectedLabel: 'Liechtenstein',
    label: 'Liechtenstein',
  },
  {
    value: 'LT',
    selectedLabel: 'Lithuania',
    label: 'Lithuania',
  },
  {
    value: 'LU',
    selectedLabel: 'Luxembourg',
    label: 'Luxembourg',
  },
  {
    value: 'MO',
    selectedLabel: 'Macau SAR China',
    label: 'Macau SAR China',
  },
  {
    value: 'MK',
    selectedLabel: 'Macedonia',
    label: 'Macedonia',
  },
  {
    value: 'MG',
    selectedLabel: 'Madagascar',
    label: 'Madagascar',
  },
  {
    value: 'MW',
    selectedLabel: 'Malawi',
    label: 'Malawi',
  },
  {
    value: 'MY',
    selectedLabel: 'Malaysia',
    label: 'Malaysia',
  },
  {
    value: 'MV',
    selectedLabel: 'Maldives',
    label: 'Maldives',
  },
  {
    value: 'ML',
    selectedLabel: 'Mali',
    label: 'Mali',
  },
  {
    value: 'MT',
    selectedLabel: 'Malta',
    label: 'Malta',
  },
  {
    value: 'MH',
    selectedLabel: 'Marshall Islands',
    label: 'Marshall Islands',
  },
  {
    value: 'MQ',
    selectedLabel: 'Martinique',
    label: 'Martinique',
  },
  {
    value: 'MR',
    selectedLabel: 'Mauritania',
    label: 'Mauritania',
  },
  {
    value: 'MU',
    selectedLabel: 'Mauritius',
    label: 'Mauritius',
  },
  {
    value: 'YT',
    selectedLabel: 'Mayotte',
    label: 'Mayotte',
  },
  {
    value: 'MX',
    selectedLabel: 'Mexico',
    label: 'Mexico',
  },
  {
    value: 'FM',
    selectedLabel: 'Micronesia, Federated States of',
    label: 'Micronesia, Federated States of',
  },
  {
    value: 'MD',
    selectedLabel: 'Moldova',
    label: 'Moldova',
  },
  {
    value: 'MC',
    selectedLabel: 'Monaco',
    label: 'Monaco',
  },
  {
    value: 'MN',
    selectedLabel: 'Mongolia',
    label: 'Mongolia',
  },
  {
    value: 'ME',
    selectedLabel: 'Montenegro',
    label: 'Montenegro',
  },
  {
    value: 'MS',
    selectedLabel: 'Montserrat',
    label: 'Montserrat',
  },
  {
    value: 'MA',
    selectedLabel: 'Morocco',
    label: 'Morocco',
  },
  {
    value: 'MZ',
    selectedLabel: 'Mozambique',
    label: 'Mozambique',
  },
  {
    value: 'MM',
    selectedLabel: 'Myanmar [Burma]',
    label: 'Myanmar [Burma]',
  },
  {
    value: 'NA',
    selectedLabel: 'Namibia',
    label: 'Namibia',
  },
  {
    value: 'NR',
    selectedLabel: 'Nauru',
    label: 'Nauru',
  },
  {
    value: 'NP',
    selectedLabel: 'Nepal',
    label: 'Nepal',
  },
  {
    value: 'NL',
    selectedLabel: 'Netherlands',
    label: 'Netherlands',
  },
  {
    value: 'AN',
    selectedLabel: 'Netherlands Antilles',
    label: 'Netherlands Antilles',
  },
  {
    value: 'NC',
    selectedLabel: 'New Caledonia',
    label: 'New Caledonia',
  },
  {
    value: 'NZ',
    selectedLabel: 'New Zealand',
    label: 'New Zealand',
  },
  {
    value: 'NI',
    selectedLabel: 'Nicaragua',
    label: 'Nicaragua',
  },
  {
    value: 'NE',
    selectedLabel: 'Niger',
    label: 'Niger',
  },
  {
    value: 'NG',
    selectedLabel: 'Nigeria',
    label: 'Nigeria',
  },
  {
    value: 'NU',
    selectedLabel: 'Niue',
    label: 'Niue',
  },
  {
    value: 'NF',
    selectedLabel: 'Norfolk Island',
    label: 'Norfolk Island',
  },
  {
    value: 'MP',
    selectedLabel: 'Northern Mariana Islands',
    label: 'Northern Mariana Islands',
  },
  {
    value: 'NO',
    selectedLabel: 'Norway',
    label: 'Norway',
  },
  {
    value: 'OM',
    selectedLabel: 'Oman',
    label: 'Oman',
  },
  {
    value: 'PK',
    selectedLabel: 'Pakistan',
    label: 'Pakistan',
  },
  {
    value: 'PW',
    selectedLabel: 'Palau',
    label: 'Palau',
  },
  {
    value: 'PS',
    selectedLabel: 'Palestinian Interim Self-Government Authority',
    label: 'Palestinian Interim Self-Government Authority',
  },
  {
    value: 'PA',
    selectedLabel: 'Panama',
    label: 'Panama',
  },
  {
    value: 'PG',
    selectedLabel: 'Papua New Guinea',
    label: 'Papua New Guinea',
  },
  {
    value: 'PY',
    selectedLabel: 'Paraguay',
    label: 'Paraguay',
  },
  {
    value: 'PE',
    selectedLabel: 'Peru',
    label: 'Peru',
  },
  {
    value: 'PH',
    selectedLabel: 'Philippines',
    label: 'Philippines',
  },
  {
    value: 'PN',
    selectedLabel: 'Pitcairn Island',
    label: 'Pitcairn Island',
  },
  {
    value: 'PL',
    selectedLabel: 'Poland',
    label: 'Poland',
  },
  {
    value: 'PT',
    selectedLabel: 'Portugal',
    label: 'Portugal',
  },
  {
    value: 'PR',
    selectedLabel: 'Puerto Rico',
    label: 'Puerto Rico',
  },
  {
    value: 'QA',
    selectedLabel: 'Qatar',
    label: 'Qatar',
  },
  {
    value: 'RO',
    selectedLabel: 'Romania',
    label: 'Romania',
  },
  {
    value: 'RU',
    selectedLabel: 'Russia',
    label: 'Russia',
  },
  {
    value: 'RW',
    selectedLabel: 'Rwanda',
    label: 'Rwanda',
  },
  {
    value: 'RE',
    selectedLabel: 'Reunion',
    label: 'Reunion',
  },
  {
    value: 'SH',
    selectedLabel: 'St. Helena',
    label: 'St. Helena',
  },
  {
    value: 'KN',
    selectedLabel: 'St. Kitts and Nevis',
    label: 'St. Kitts and Nevis',
  },
  {
    value: 'LC',
    selectedLabel: 'St. Lucia',
    label: 'St. Lucia',
  },
  {
    value: 'PM',
    selectedLabel: 'St. Pierre and Miquelon',
    label: 'St. Pierre and Miquelon',
  },
  {
    value: 'VC',
    selectedLabel: 'St. Vincent and the Grenadines',
    label: 'St. Vincent and the Grenadines',
  },
  {
    value: 'WS',
    selectedLabel: 'Samoa',
    label: 'Samoa',
  },
  {
    value: 'SM',
    selectedLabel: 'San Marino',
    label: 'San Marino',
  },
  {
    value: 'BL',
    selectedLabel: 'Saint Barthelemy',
    label: 'Saint Barthelemy',
  },
  {
    value: 'MF',
    selectedLabel: 'Saint Martin',
    label: 'Saint Martin',
  },
  {
    value: 'SA',
    selectedLabel: 'Saudi Arabia',
    label: 'Saudi Arabia',
  },
  {
    value: 'SN',
    selectedLabel: 'Senegal',
    label: 'Senegal',
  },
  {
    value: 'RS',
    selectedLabel: 'Serbia',
    label: 'Serbia',
  },
  {
    value: 'SC',
    selectedLabel: 'Seychelles',
    label: 'Seychelles',
  },
  {
    value: 'SL',
    selectedLabel: 'Sierra Leone',
    label: 'Sierra Leone',
  },
  {
    value: 'SG',
    selectedLabel: 'Singapore',
    label: 'Singapore',
  },
  {
    value: 'SK',
    selectedLabel: 'Slovakia',
    label: 'Slovakia',
  },
  {
    value: 'SI',
    selectedLabel: 'Slovenia',
    label: 'Slovenia',
  },
  {
    value: 'SB',
    selectedLabel: 'Solomon Islands',
    label: 'Solomon Islands',
  },
  {
    value: 'SO',
    selectedLabel: 'Somalia',
    label: 'Somalia',
  },
  {
    value: 'ZA',
    selectedLabel: 'South Africa',
    label: 'South Africa',
  },
  {
    value: 'GS',
    selectedLabel: 'South Georgia and the South Sandwich Islands',
    label: 'South Georgia and the South Sandwich Islands',
  },
  {
    value: 'ES',
    selectedLabel: 'Spain',
    label: 'Spain',
  },
  {
    value: 'LK',
    selectedLabel: 'Sri Lanka',
    label: 'Sri Lanka',
  },
  {
    value: 'SD',
    selectedLabel: 'Sudan',
    label: 'Sudan',
  },
  {
    value: 'SR',
    selectedLabel: 'Suriname',
    label: 'Suriname',
  },
  {
    value: 'SJ',
    selectedLabel: 'Svalbard and Jan Mayen Islands',
    label: 'Svalbard and Jan Mayen Islands',
  },
  {
    value: 'SZ',
    selectedLabel: 'Swaziland',
    label: 'Swaziland',
  },
  {
    value: 'SE',
    selectedLabel: 'Sweden',
    label: 'Sweden',
  },
  {
    value: 'CH',
    selectedLabel: 'Switzerland',
    label: 'Switzerland',
  },
  {
    value: 'SY',
    selectedLabel: 'Syria',
    label: 'Syria',
  },
  {
    value: 'ST',
    selectedLabel: 'Sao Tome and Principe',
    label: 'Sao Tome and Principe',
  },
  {
    value: 'TW',
    selectedLabel: 'Taiwan',
    label: 'Taiwan',
  },
  {
    value: 'TJ',
    selectedLabel: 'Tajikistan',
    label: 'Tajikistan',
  },
  {
    value: 'TZ',
    selectedLabel: 'Tanzania',
    label: 'Tanzania',
  },
  {
    value: 'TH',
    selectedLabel: 'Thailand',
    label: 'Thailand',
  },
  {
    value: 'TL',
    selectedLabel: 'Timor-Leste',
    label: 'Timor-Leste',
  },
  {
    value: 'TG',
    selectedLabel: 'Togo',
    label: 'Togo',
  },
  {
    value: 'TK',
    selectedLabel: 'Tokelau (Tokelau Islands)',
    label: 'Tokelau (Tokelau Islands)',
  },
  {
    value: 'TO',
    selectedLabel: 'Tonga',
    label: 'Tonga',
  },
  {
    value: 'TT',
    selectedLabel: 'Trinidad and Tobago',
    label: 'Trinidad and Tobago',
  },
  {
    value: 'TN',
    selectedLabel: 'Tunisia',
    label: 'Tunisia',
  },
  {
    value: 'TR',
    selectedLabel: 'Turkey',
    label: 'Turkey',
  },
  {
    value: 'TM',
    selectedLabel: 'Turkmenistan',
    label: 'Turkmenistan',
  },
  {
    value: 'TC',
    selectedLabel: 'Turks and Caicos Islands',
    label: 'Turks and Caicos Islands',
  },
  {
    value: 'TV',
    selectedLabel: 'Tuvalu',
    label: 'Tuvalu',
  },
  {
    value: 'UM',
    selectedLabel: 'U.S. Minor Outlying Islands',
    label: 'U.S. Minor Outlying Islands',
  },
  {
    value: 'VI',
    selectedLabel: 'U.S. Virgin Islands',
    label: 'U.S. Virgin Islands',
  },
  {
    value: 'UG',
    selectedLabel: 'Uganda',
    label: 'Uganda',
  },
  {
    value: 'UA',
    selectedLabel: 'Ukraine',
    label: 'Ukraine',
  },
  {
    value: 'AE',
    selectedLabel: 'United Arab Emirates',
    label: 'United Arab Emirates',
  },
  {
    value: 'GB',
    selectedLabel: 'United Kingdom',
    label: 'United Kingdom',
  },
  {
    value: 'US',
    selectedLabel: 'United States',
    label: 'United States',
  },
  {
    value: 'UY',
    selectedLabel: 'Uruguay',
    label: 'Uruguay',
  },
  {
    value: 'UZ',
    selectedLabel: 'Uzbekistan',
    label: 'Uzbekistan',
  },
  {
    value: 'VU',
    selectedLabel: 'Vanuatu',
    label: 'Vanuatu',
  },
  {
    value: 'VA',
    selectedLabel: 'Vatican City',
    label: 'Vatican City',
  },
  {
    value: 'VE',
    selectedLabel: 'Venezuela',
    label: 'Venezuela',
  },
  {
    value: 'VN',
    selectedLabel: 'Vietnam',
    label: 'Vietnam',
  },
  {
    value: 'WF',
    selectedLabel: 'Wallis and Futuna Islands',
    label: 'Wallis and Futuna Islands',
  },
  {
    value: 'EH',
    selectedLabel: 'Western Sahara',
    label: 'Western Sahara',
  },
  {
    value: 'YE',
    selectedLabel: 'Yemen',
    label: 'Yemen',
  },
  {
    value: 'ZM',
    selectedLabel: 'Zambia',
    label: 'Zambia',
  },
  {
    value: 'ZW',
    selectedLabel: 'Zimbabwe',
    label: 'Zimbabwe',
  },
];
